import React, { useEffect } from 'react';
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import { formatFormTitle, FormikMultiFormSync, ucFirst } from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";
import { COUNTRIES } from "../../../../../../util/constants/Countries";
import { NIGERIAN_STATES } from '../../../../../../util/constants/NigerianStates';

// Synchronize postal code with state for Nigerian KYC
const PostalCodeSync = () => {
    // Grab values from context
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        (values?.country === "NGA" && NIGERIAN_STATES[values?.city]) && setFieldValue("postalCode", NIGERIAN_STATES[values?.city] || "")
    }, [values, setFieldValue]);

    return null;
};

function AddressDetail(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            addressData = {}
        }
    }
) {
    const validationSchema = Yup.object({
        street1: Yup.string().required('Required'),
        street2: Yup.string(),
        postalCode: Yup.string().required('Required'),
        city: Yup.string().required('Required'),
        province: Yup.string().required('Required'),
        country: Yup.string().required('Required'),
    })

    const compiledInitialValues = {
        street1: "",
        street2: "",
        postalCode: "",
        province: "",
        country: "",
        ...addressData,
        city: ucFirst(addressData?.city),
    }

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({ isValid, values }) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({ title, isValid })}
                            <FormLayout.Row>
                                <TextInput
                                    label="Address Line 1*"
                                    name="street1"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Address Line 2"
                                    name="street2"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <SelectInput
                                    label="Country*"
                                    name="country"
                                    options={COUNTRIES}
                                />
                                <TextInput
                                    label="State*"
                                    name="city"
                                    type="text"
                                    list="states"
                                    style={{ "textTransform": "capitalize" }}
                                />
                                {
                                    values?.country === "NGA" &&
                                    <datalist id="states">
                                        {Object.keys(NIGERIAN_STATES).map(state => <option value={state} key={state}/>)}
                                    </datalist>
                                }
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Postcode*"
                                    name="postalCode"
                                    type="text"
                                />
                                <TextInput
                                    label="City*"
                                    name="province"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <PostalCodeSync />
                            <FormikMultiFormSync name={dataKey} />
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default AddressDetail;